import axios from "axios";

export const scrapeJobs = async (applicationId) => {
    const result = await axios.post(
        `/api/applications/${applicationId}/scrape`,
        {},
        {
            timeout: 180000,
        }
    );

    return result.data;
};

export const deleteJob = async (jobId) => {
    const response = await axios.delete(`/api/jobs/${jobId}`);

    return response.data;
};

export const applyToJobs = async (jobs) => {
    const result = await axios.post(`/api/applications/apply`, { jobs }, {
        validateStatus: (status) => true
    });

    return result;
};

export const getFormFields = async (job) => {
    const result = await axios.post(`/api/applications/form-fields`, { job: job }, {
        validateStatus: (status) => true
    });

    return result;
};

export const applyToJobCustomAnswer = async (job, data) => {
    const result = await axios.post(`/api/applications/apply-job-custom-answers`, { job: job, formData: data }, {
        validateStatus: (status) => true
    });

    return result;
};

export const createApplication = async (applicationData) => {
    const result = await axios.post(`/api/applications`, applicationData);

    return result.data;
};

export const getApplicationJobs = async (applicationId) => {
    const result = await axios.get(`/api/applications/${applicationId}/jobs`);

    return result.data;
};

export const getApplications = async () => {
    const result = await axios.get(`/api/applications`);

    return result.data;
};

export const getAllApplications = async () => {
    const result = await axios.get(`/api/applications/all`);

    return result.data;
}

export const fetchJobs = async (params) => {
    const result = await axios.get(`/api/applications/fetch-jobs`, { params: params });

    return result.data;
}

export const getFiltersMetaData = async () => {
    const result = await axios.get(`/api/applications/get-filters`);

    return result.data;
}

export const updateApplication = async (applicationId, data) => {
    const result = await axios.patch(
        `/api/applications/${applicationId}`,
        data
    );

    return result.data;
};

export const updateJobStatus = async (jobId, jobStatus) => {
    const result = await axios.post(`/api/jobs/${jobId}/set-status`, {
        status: jobStatus,
    });

    return result.data;
};

export const updateJob = async (jobId, data) => {
    const result = await axios.patch(`/api/jobs/${jobId}`,data);

    return result.data;
};

export const addJobApplication = async (data) => {
     const result = await axios.post(`/api/applications/add-job`, data)
     
    return result.data;
}

export const downloadJobApplicationTemplate = async (data) => {
     const result = await axios.post(`/api/applications/download-template`)
     
    return result.data;
}

export const importJobApplications = async (data, options) => {
    const result = await axios.post(`/api/applications/import-jobs`, data, options)
     
    return result.data;
}

export const getJobFunctions = async () => {
    const result  = await axios.get(`/api/job-functions`)
    
    return result.data;
}

export const getLocations = async () => {
    const result = await axios.get(`/api/locations`)
    
    return result.data;
}

export const getSearchHistory = async (page) => {
    const result = await axios.get(`/api/applications?page=${page}`);

    return result.data;
}

